import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-edt",
  "use": "icon-edt-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-edt\"><path d=\"M739.8 408.4c3.1 3.1 7.2 4.7 11.3 4.7 4.1 0 8.2-1.6 11.3-4.7L866 304.7c6.2-6.2 6.2-16.3 0-22.6L731.4 147.5c-3.1-3.1-7.2-4.7-11.3-4.7-4.1 0-8.2 1.6-11.3 4.7L605.1 251.2c-6.2 6.2-6.2 16.3 0 22.6l134.7 134.6z m-19.7-181.7l66.6 66.6-35.7 35.8-66.6-66.6 35.7-35.8zM709.1 438.1L575.4 304.4c-3.2-3.2-7.5-4.8-11.7-4.8-4.2 0-8.5 1.6-11.7 4.8l-400 400c-3.1 3.1-4.8 7.3-4.8 11.6l-0.6 134.3c0 9.2 7.4 16.6 16.6 16.6h0.1l134.3-0.6c4.4 0 8.5-1.8 11.6-4.8l400-400c6.4-6.4 6.4-16.9-0.1-23.4zM277.7 802.5l-66.9 0.3 0.3-66.9 352.7-352.7 66.6 66.6-352.7 352.7zM384.2 803.6h493.1v64H384.2z\" fill=\"#231815\" p-id=\"3074\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/edt.svg
// module id = IQ1u
// module chunks = 120